import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ChatbotSurvey } from './ChatbotSurvey';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [showChatbot, setShowChatbot] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80; // Account for fixed nav height
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <>
      <motion.nav initial={{
      backgroundColor: 'transparent'
    }} animate={{
      backgroundColor: isScrolled ? 'rgba(181, 234, 215, 0.97)' : 'transparent',
      backdropFilter: isScrolled ? 'blur(20px)' : 'blur(0px)'
    }} transition={{
      duration: 0.3,
      ease: 'easeInOut'
    }} className="fixed top-0 left-0 right-0 z-50 px-4 sm:px-8 md:px-[60px] py-5 border-b transition-colors" style={{
      borderBottomColor: isScrolled ? 'rgba(26, 61, 58, 0.15)' : 'transparent'
    }} data-id="element-962">
        <div className="max-w-[1400px] mx-auto flex justify-between items-center" data-id="element-963">
          <button onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} className="text-[#1A3D3A] focus:outline-none focus:ring-3 focus:ring-[#0D2926] focus:ring-offset-2 rounded" style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: '24px',
          fontWeight: 600,
          letterSpacing: '-0.5px'
        }} data-id="element-964">
            CofounderFit
            <sup style={{
            fontSize: '12px',
            fontWeight: 400
          }} data-id="element-965">
              ®
            </sup>
          </button>
          <div className="hidden md:flex gap-10 items-center" data-id="element-966">
            <button onClick={() => window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })} className="text-[#3D5654] hover:text-[#1A3D3A] transition-colors px-3 py-2 rounded hover:bg-[#1A3D3A]/5 focus:outline-none focus:ring-3 focus:ring-[#0D2926] focus:ring-offset-2" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '14px',
            fontWeight: 400,
            opacity: 0.8
          }} data-id="element-967">
              Home
            </button>
            <button onClick={() => scrollToSection('research-foundation')} className="text-[#3D5654] hover:text-[#1A3D3A] transition-colors px-3 py-2 rounded hover:bg-[#1A3D3A]/5 focus:outline-none focus:ring-3 focus:ring-[#0D2926] focus:ring-offset-2" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '14px',
            fontWeight: 400,
            opacity: 0.8
          }} data-id="element-968">
              Research
            </button>
            <button onClick={() => scrollToSection('key-findings')} className="text-[#3D5654] hover:text-[#1A3D3A] transition-colors px-3 py-2 rounded hover:bg-[#1A3D3A]/5 focus:outline-none focus:ring-3 focus:ring-[#0D2926] focus:ring-offset-2" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '14px',
            fontWeight: 400,
            opacity: 0.8
          }} data-id="element-969">
              Insights
            </button>
            <button onClick={() => scrollToSection('about')} className="text-[#3D5654] hover:text-[#1A3D3A] transition-colors px-3 py-2 rounded hover:bg-[#1A3D3A]/5 focus:outline-none focus:ring-3 focus:ring-[#0D2926] focus:ring-offset-2" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '14px',
            fontWeight: 400,
            opacity: 0.8
          }} data-id="element-970">
              About
            </button>
            <button onClick={() => setShowChatbot(true)} className="px-[24px] py-[12px] bg-[#1A3D3A] text-white rounded hover:bg-[#0D2926] hover:-translate-y-0.5 transition-all focus:outline-none focus:ring-3 focus:ring-[#0D2926] focus:ring-offset-2" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '12px',
            fontWeight: 600,
            letterSpacing: '1px',
            borderRadius: '4px'
          }} data-id="element-971">
              JOIN STUDY
            </button>
          </div>
        </div>
      </motion.nav>

      {showChatbot && <ChatbotSurvey onClose={() => setShowChatbot(false)} data-id="element-972" />}
    </>;
}